module.exports = __webpack_public_path__ + "static/media/036-hand.99085e7d.svg";